import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { Card } from "react-bootstrap";

const COLORS = [
  "#004d40",
  "#00796b",
  "#26a69a",
  "#80cbc4",
  "#b2dfdb",
  "#a7ffeb",
  "#80cbc4",
];

const CategoryChart = ({ data }) => {
  // Ensure data is always an array
  const chartData = Array.isArray(data) ? data : [];

  return (
    <Card className="mb-3 bucket-card-holder">
      <div className="card-heading-holder">
        <h6>Category-wise Profit</h6>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            outerRadius={90}
            dataKey="value"
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`} // only show %
            labelLine={false} // remove connecting lines
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, props) => [
              value.toLocaleString(),
              props?.payload?.name || "Category",
            ]}
          />
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="middle"
            iconType="circle"
          />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default CategoryChart;
